// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"806":"775bf0404bf6fd3c","922":"4e5150fb8bb8557e"}[chunkId] + ".js";
};